"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _configuration = require("@/api/configuration");
var _vuexModuleDecorators = require("vuex-module-decorators");
var ConfigurationStore = /*#__PURE__*/function (_VuexModule) {
  function ConfigurationStore() {
    var _this;
    (0, _classCallCheck2.default)(this, ConfigurationStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ConfigurationStore, [].concat(args));
    (0, _defineProperty2.default)(_this, "list", {});
    return _this;
  }
  (0, _inherits2.default)(ConfigurationStore, _VuexModule);
  return (0, _createClass2.default)(ConfigurationStore, [{
    key: "SET_LIST",
    value: function SET_LIST(list) {
      this.list = list;
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, list;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _configuration.configurationApi.findAll();
            case 2:
              res = _context.sent;
              list = {};
              res.data.configurations.forEach(function (e) {
                if (!list[e.param]) {
                  list[e.param] = (0, _objectSpread2.default)({}, e);
                }
              });
              _context.next = 7;
              return this.context.commit('SET_LIST', list);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuexModuleDecorators.VuexModule);
(0, _tslib.__decorate)([_vuexModuleDecorators.Mutation], ConfigurationStore.prototype, "SET_LIST", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], ConfigurationStore.prototype, "fetchData", null);
ConfigurationStore = (0, _tslib.__decorate)([(0, _vuexModuleDecorators.Module)({
  name: 'configuration',
  namespaced: true
})], ConfigurationStore);
var _default = exports.default = ConfigurationStore;